<template>
    <n-result status="success" title="Dashboard"
        description="A dashboard scaffolding based on Vue.js 3.x created by Vite." size="huge">
        <template #footer>
            <n-button @click="handleClick">Just So So</n-button>
        </template>
    </n-result>
</template>

<script>

import { mapState } from 'pinia';
import { useMessage } from 'naive-ui'
import authStore from '../../store/auth';

export default {
    name: "DashboardUser",
    data(){
        return{
            message: useMessage()
        }
    },
    methods: {
        handleClick: () => {
            this.message.success('Just So So')
        }
    },
    computed: {
        ...mapState(authStore, ['isLoggedIn', 'isAdmin'])
    },
    mounted(){
        if(!this.isLoggedIn) {
            this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
            this.$router.push('/app/login');
        } else {
            if (this.isAdmin){
                this.message.info("No posees el rol necesario para acceder a esta ruta", { duration: 5000 });
                this.$router.push('/app/dashboard/admin')
            }
        }
    }
}
</script>

<style scoped>
.n-result {
    margin: 10vh 0;
}
</style>